import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router, RoutesRecognized } from "@angular/router";
import { filter, pairwise } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ExtraRouterService {

  private _previousUrl: string = null;
  private _currentUrl: string = null;

  constructor(private router: Router) {
    this._currentUrl = this.router.url;
    router.events.pipe(
      filter(event => event instanceof RoutesRecognized),
      pairwise()
    ).subscribe((events: Event[]) => {
      this._previousUrl = (events[0] as RoutesRecognized).urlAfterRedirects;
      this._currentUrl = (events[1] as RoutesRecognized).urlAfterRedirects;
    });
  }

  get previousUrl() {
    return this._previousUrl;
  }

  get currentUrl() {
    return this._currentUrl;
  }
}
